import { createFileRoute } from '@tanstack/react-router';

import { TeamDetailPage } from '@/pages/teams/team-detail-page';

export const Route = createFileRoute('/teams/$id')({
  component: TeamDetail,
});

function TeamDetail() {
  const { id } = Route.useParams();
  return <TeamDetailPage id={id} />;
}
